export default {
  // FrontPage.vue
  frontPageRequirementTitle: 'मेरा',
  frontPageProvideTitle: 'उपलब्ध',
  frontPagePersonalCenterTitle: 'प्रोफ़ाइल',
  login: 'लॉगिन',
  home_chatWithOctopie: 'आपके विचारों को समझ रहे हैं',
  home_chatNeedUnderstood: 'आपके विचार समझ लिए गए',
  home_draftBannerTitle: 'अपना संदेश पूरा करें',
  home_draftBannerSubtitle: 'AI ने आपका संदेश तैयार कर दिया है — जारी रखने के लिए टैप करें',
  home_tabHome: 'होम',

  // App.vue
  appRequirementTitle: 'हम हर सुझाव और फीडबैक को ध्यान से सुनते हैं',
  appRequirementBtn: 'सबमिट करें',
  appSubmitSuccess: 'सफलतापूर्वक सबमिट हुआ, फीडबैक के लिए धन्यवाद',
  appFeedbackLink: 'सुझाव/फीडबैक',
  mobile_banner_text: 'सबसे अच्छे अनुभव के लिए हमारा ऐप इस्तेमाल करें',
  mobile_banner_btn: 'ऐप पाएं',

  // Common
  loading: 'लोड हो रहा है...',
  confirm: 'पुष्टि करें',
  cancel: 'रद्द करें',
  save: 'सेव करें',
  delete: 'डिलीट करें',
  edit: 'एडिट करें',
  add: 'जोड़ें',
  search: 'खोजें',
  refresh: 'रिफ्रेश',
  change_batch: 'बदलें',
  back: 'वापस',
  submit: 'सबमिट करें',
  close: 'बंद करें',
  ok: 'ठीक है',
  yes: 'हां',
  no: 'नहीं',
  send: 'भेजें',
  block: 'ब्लॉक करें',
  more: 'और',
  logout: 'लॉगआउट',
  settings: 'सेटिंग्स',
  view_guide: 'गाइड देखें',
  feedback: 'सुझाव',
  feedback_title: 'सुझाव',
  feedback_new: 'नया सुझाव',
  feedback_empty: 'अभी कोई सुझाव नहीं',
  feedback_hint: 'अपनी राय बताएं...',
  feedback_submit: 'सबमिट करें',
  feedback_submit_success: 'सुझाव सफलतापूर्वक सबमिट हुआ',
  feedback_submit_failed: 'सुझाव सबमिट करने में विफल',
  feedback_reply_label: 'प्लेटफ़ॉर्म की ओर से जवाब',
  register: 'रजिस्टर',
  name: 'नाम',
  email: 'ईमेल',
  mobile: 'मोबाइल',
  password: 'पासवर्ड',
  verification_code: 'सत्यापन कोड',
  company_name: 'Beijing Liangshao Technology Co., Ltd.',
  all_rights_reserved: 'सर्वाधिकार सुरक्षित।',
  footerVersion: 'वर्शन {version}',
  copy: 'कॉपी करें',
  regenerate: 'दोबारा बनाएं',
  generate: 'बनाएं',
  contact_now: 'चैट',
  yours: 'आप',
  xiaoyao_analysis: 'AI विश्लेषण',
  brand_name: 'OctoSay',
  anonymous: 'अनाम',
  no_summary: 'सारांश नहीं',
  file: 'फ़ाइल',
  discover: 'खोजें',
  discover_title: 'खोजें',
  discover_hotChannels: 'लोकप्रिय चैनल',
  discover_allChannels: 'सभी',
  discover_searchChannel: 'चैनल खोजें',
  discover_noChannels: 'कोई चैनल नहीं मिला',

  // Messages
  operationSuccess: 'काम सफल रहा',
  operationFailed: 'काम विफल',
  networkError: 'नेटवर्क त्रुटि, बाद में कोशिश करें',
  dataLoadingFailed: 'डेटा लोड करने में विफल',
  noData: 'कोई डेटा नहीं',
  deleteConfirm: 'क्या आप वाकई डिलीट करना चाहते हैं?',
  saveConfirm: 'क्या आप वाकई सेव करना चाहते हैं?',

  // Form Validation
  required: 'यह फ़ील्ड ज़रूरी है',
  emailInvalid: 'कृपया मान्य ईमेल पता दर्ज करें',
  phoneInvalid: 'कृपया मान्य फ़ोन नंबर दर्ज करें',
  passwordTooShort: 'पासवर्ड कम से कम {min} अक्षरों का होना चाहिए',
  passwordMismatch: 'पासवर्ड मेल नहीं खाते',

  // Time
  today: 'आज',
  yesterday: 'कल',
  justNow: 'अभी',
  minutesAgo: '{min} मिनट पहले',
  hoursAgo: '{hour} घंटे पहले',
  daysAgo: '{day} दिन पहले',

  // Footer
  about: 'के बारे में',
  footerPrivacy: 'गोपनीयता नीति',
  footerTerms: 'सेवा की शर्तें',
  footerSupport: 'सहायता और सपोर्ट',

  // Register
  registerAgeConfirm: 'मैं पुष्टि करता/करती हूँ कि मैं कम से कम 13 साल का/की हूँ',
  registerAgeConfirm18: 'मैं पुष्टि करता हूँ कि मेरी आयु कम से कम 18 वर्ष है',
  registerTermsPrefix: 'मैंने पढ़ लिया और सहमत हूँ',
  registerTermsAnd: 'और',
  registerAgeError: 'कृपया अपनी उम्र की पुष्टि करें',
  registerTermsError: 'कृपया शर्तें और गोपनीयता नीति स्वीकार करें',

  // Chat
  chatPrivacyTip: 'समूह में अपना संदेश लिखें और AI पहले आपसे बात करके बातें साफ करेगा। पुष्टि करने पर आपका संदेश और AI सारांश साथ पोस्ट होंगे और AI लगातार मैच ढूंढेगा।',
  aiChat_quickSuggestions: 'इस तरह कहें',
  aiChat_welcome: "नमस्ते! बताओ आप क्या ढूंढ रहे हैं।",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: 'बातें समझ ली गईं — मैच पाने के लिए पोस्ट करें',
  aiChat_readyToPostHint: 'बातें जोड़ने या सारांश अपडेट करने के लिए कभी भी बातचीत जारी रखें',
  aiChat_progressStep1: 'बातें समझें',
  aiChat_progressStep1Done: 'बातें समझ लीं',
  aiChat_progressStep2: 'AI सारांश',
  aiChat_progressStep2Desc: 'AI मैचिंग के लिए सारांश बनाता है',
  aiChat_progressStep3: 'समूह में पोस्ट करें',
  aiChat_progressStep3Desc: 'पोस्ट करें और मैच पाएं',
  aiChat_publishExtraHint: 'समूह के लिए अपना संदेश दर्ज करें',
  aiChat_publishMsgRequired: 'ज़रूरी',
  aiChat_publishMsgLabel: 'समूह के लिए आपका संदेश',
  aiChat_matchSummaryLabel: 'AI सारांश',

  ai_generated_label: 'AI Generated',

  ai_content_disclaimer: 'निम्नलिखित सामग्री AI द्वारा बनाई गई है और केवल संदर्भ के लिए है।',
  aiChat_publishSuggestionHint: 'बदलने के लिए टैप करें',
  aiChat_allowDirectContact: 'सीधा संपर्क की अनुमति दें',
  aiChat_allowDirectContactDesc: 'दूसरे बिना मैच के भी आपसे सीधा संपर्क कर सकते हैं',
  channel_chat_session_publishToChannel: 'Octo समूह में पोस्ट करें',
  aiChat_newChat: 'रीसेट करें',

  // Channels / समूह
  home_tabChannels: 'Octo समूह',
  channels_title: 'Octo समूह',
  channels_myChannels: 'जुड़े हुए समूह',
  channels_discover: 'खोजें',
  channels_noChannels: 'अभी कोई hub नहीं',
  channels_noMyGroupsTitle: 'आपने अभी किसी hub से जुड़े नहीं हैं',
  channels_noMyGroupsSubtitle: 'जुड़ने के लिए hub खोजें और नए लोगों से मिलना शुरू करें',
  channels_searchGroupsBtn: 'समूह खोजें',
  channels_loginPrompt: 'hubs देखने के लिए लॉगिन करें',
  channels_create: 'Octo समूह बनाएं',
  channels_search: 'Octo समूह खोजें',
  channels_searchMyGroups: 'मेरे Octo समूह खोजें',
  channels_searchHint: 'खोजें',
  channels_searchHintChats: 'चैट खोजें...',
  channels_searchHintGroups: 'समूह खोजें...',
  channels_searchHintMy: 'जुड़े हुए hubs खोजें...',
  channels_joinByCode: 'कोड से जुड़ें',
  channels_joinByCodeTitle: 'कोड से Octo समूह से जुड़ें',
  channels_joinByCodeHint: 'Octo समूह कोड दर्ज करें',
  channels_joinByCodeConfirm: 'जुड़ें',
  channels_joinByCodeNotFound: 'समूह नहीं मिला',
  channels_createNewGroup: 'नया Octo समूह बनाएं',
  channels_noResults: 'कोई hub नहीं मिला',
  channel_detail_join: 'जुड़ें',
  channel_detail_leave: 'छोड़ें',
  channel_detail_members: 'सदस्य',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name} शामिल हुए',
  channelJoinMsg_twoJoined: '{name1} और {name2} शामिल हुए',
  channelJoinMsg_multiJoined: '{name1}, {name2} और {n} अन्य शामिल हुए',
  channelJoinMsg_oneAndMoreJoined: '{name} और {n} अन्य शामिल हुए',
  channelJoinMsg_membersJoined: '{n} सदस्य शामिल हुए',

  // Feed
  channels_feed: 'चैट',
  channels_groups: 'समूह',
  feed_related: 'संबंधित',
  feed_recommend: 'सुझाव',
  feed_empty: 'अभी कोई फीड नहीं, लोकप्रिय hubs देखें',
  feed_goToGroup: 'समूह में देखें',
  feed_joinGroupAndSendMsg: 'समूह से जुड़ें और संदेश भेजें',
  channel_detail_channelCode: 'Octo समूह कोड',
  channel_detail_invitePhrase: '"{name}" में आमंत्रित हैं\nइनवाइट कोड {code} — ऐप खोलें, अपने आप जुड़ जाएँ · AI पहले डिटेल साफ़ करता है, फिर सही लोग ढूँढता है',
  channel_detail_post: 'समूह में पोस्ट करें',
  channel_detail_aiHint: "समूह में अपना संदेश लिखें और AI पहले बातें साफ करेगा",
  channel_input_hint: 'कुछ कहें...',
  channel_leave_confirm_message: 'क्या आप वाकई इस hub को छोड़ना चाहते हैं? आपको hub संदेश अब नहीं मिलेंगे।',
  channel_invite_notFound: 'समूह नहीं मिला या लिंक समाप्त हो गया',
  channel_invite_joinBtn: 'OctoSay ऐप डाउनलोड करें',
  channel_invite_hint: 'ऐप डाउनलोड करें, फिर इस QR कोड को स्कैन करें या hub का नाम खोजें और जुड़ें',
  channel_invite_globalHintTitle: 'आप ग्लोबल वर्शन डाउनलोड करने जा रहे हैं',
  channel_invite_globalHintIOS: 'यह ऐप चीन App Store में उपलब्ध नहीं हो सकता। कृपया चीन के बाहर के Apple Store पर जाकर OctoSay खोजें, या नीचे से APK सीधे डाउनलोड करें।',
  channel_invite_globalHintAndroid: 'आपके क्षेत्र में Google Play उपलब्ध नहीं हो सकता। हम APK सीधे डाउनलोड करने की सलाह देते हैं, या Google Play आज़माएं।',
  channel_invite_globalHintDefault: 'यह ऐप आपकी लोकल ऐप स्टोर में उपलब्ध नहीं हो सकता। हम APK सीधे डाउनलोड करने की सलाह देते हैं, या App Store आज़माएं।',
  channel_invite_globalBtnAppStore: 'App Store पर जाएं',
  channel_invite_globalBtnGooglePlay: 'Google Play पर जाएं',
  channel_invite_globalBtnAPK: 'APK सीधे डाउनलोड करें',
  channel_invite_defaultDesc: 'OctoSay पर {name} से जुड़ें',
  share: 'शेयर करें',
  share_channel: 'समूह शेयर करें',
  share_channel_link: 'लिंक शेयर करें',
  channel_detail_inviteCode: 'इनवाइट कोड',
  channel_detail_copyLink: 'लिंक कॉपी करें',
  share_session_title: 'OctoSay पर एक पोस्ट',
  share_match_title: 'OctoSay पर एक मैच',
  share_session_text: '{userName}: {summary}',
  share_session_text_no_summary: 'देखें {userName} ने OctoSay पर क्या पोस्ट किया',
  session_share_notFound: 'पोस्ट नहीं मिली या लिंक समाप्त हो गया',
  session_share_fromChannel: 'Octo समूह से',
  session_share_downloadBtn: 'OctoSay ऐप डाउनलोड करें',
  session_share_hint: 'पूरी पोस्ट देखने और hub से जुड़ने के लिए ऐप डाउनलोड करें',
  session_share_openInApp: 'ऐप में खोलें',
  toast_link_copied: 'लिंक कॉपी हुआ',
  toast_no_share_data: 'शेयर करने लायक कुछ नहीं',
  channels_joinByQR: 'QR कोड',
  channels_joinByQRWebHint: 'वेब QR स्कैन को सपोर्ट नहीं करता। कृपया hub कोड दर्ज करके जुड़ें।',
  channels_joinByQRTitle: 'QR कोड से जुड़ें',
  channel_detail_qrCode: 'QR कोड',
  channel_detail_qrCodeSave: 'इमेज सेव करें',
  channel_detail_qrCodeSaveHint: 'सेव करने के लिए इमेज पर राइट-क्लिक करें',
  channel_detail_qrCodeSaved: 'गैलरी में सेव हुआ',
  channel_detail_qrCodeSaveFailed: 'सेव करने में विफल, फिर से कोशिश करें',
  channel_detail_locateFailed: 'संदेश की जगह ढूंढने में विफल',
  channel_detail_locateError: 'संदेश की जगह ढूंढने में त्रुटि',
  channel_detail_myMessages: 'मेरे संदेश',
  channel_detail_searchMessages: 'संदेश खोजें',
  channel_detail_aiChat: 'AI चैट',
  channel_detail_matchHistory: 'मैच हिस्ट्री',
  channel_create_title: 'Octo समूह बनाएं',
  channel_create_name: 'Octo समूह का नाम',
  channel_create_description: 'विवरण',
  channel_create_submit: 'बनाएं',
  channelCreate_aiAssist: 'AI आपको उपयुक्त hub बनाने में मदद करेगा',
  channelCreate_nameHint: 'अपने hub का नाम दर्ज करें',
  channelCreate_descHint: 'बताएं कि आपका hub किस बारे में है',
  channelCreate_creating: 'बन रहा है...',
  channelCreate_created: 'समूह बन गया!',
  channelCreate_failed: 'समूह बनाने में विफल',
  channelCreate_welcomeMsg: "नमस्ते! मैं आपको hub बनाने में मदद करने के लिए यहां हूं। बताइए कैसा hub चाहिए — उसका नाम, विषय या उद्देश्य — और मैं उसे hub के नाम और परिचय में बदलकर अवतार भी बनाने में मदद करूंगा।",
  channelCreate_aiHint: 'अपने hub का विषय लिखें...',
  channelCreate_clarifyingProgress: 'आपके hub का विषय व्यवस्थित हो रहा है...',
  channelCreate_readyToCreate: 'Octo समूह बनाने के लिए तैयार',
  channelCreate_step1: 'विषय बताएं',
  channelCreate_step1Done: 'आइडिया साफ हो गया',
  channelCreate_step2: 'Octo समूह बनाएं',
  channelCreate_confirmBtn: 'बनाने की पुष्टि करें',
  channelCreate_publicNotice: 'समूह सार्वजनिक जगहें हैं जहां समान रुचि वाले लोग मिलते और जुड़ते हैं। प्लेटफ़ॉर्म ज़रूरत के अनुसार hubs को प्रबंधित, अपडेट या मिला सकता है। इस hub को दूसरों के साथ शेयर करने में संकोच न करें जिन्हें रुचि हो सकती है।',
  channelCreate_similarGroupsTitle: 'समान Octo समूह मिले',
  channelCreate_similarGroupsDesc: 'ये hubs आपकी बात से मेल खा सकते हैं',
  channelCreate_exactMatchHint: 'इसी नाम का hub पहले से मौजूद है!',
  channelCreate_joinHint: 'ये मौजूदा hubs अच्छे फिट हो सकते हैं',
  channelCreate_joinExisting: 'मौजूदा Octo समूह से जुड़ें',
  channelCreate_stillCreate: 'फिर भी नया Octo समूह बनाएं',
  channel_chat_session_comments: 'टिप्पणियां',
  channel_chat_session_commentHint: 'टिप्पणी लिखें...',
  channel_chat_session_sendComment: 'टिप्पणी',
  channel_chat_session_loadMore: 'और लोड करें',
  channel_chat_session_noComments: 'अभी कोई टिप्पणी नहीं',
  channel_chat_session_deleteComment: 'डिलीट करें',
  channelSearch_title: 'समूह में खोजें',
  channelSearch_placeholder: 'संदेश खोजें...',
  channelSearch_onlyMine: 'सिर्फ मेरी पोस्ट',
  channelSearch_tabAllMessages: 'समूह संदेश',
  channelSearch_tabMyMessages: 'मेरे संदेश',
  chatMsgSearch_placeholder: 'संदेश खोजें',
  chatMsgSearch_tabMsgs: 'संदेश',
  chatMsgSearch_tabContacts: 'संपर्क',
  chatMsgSearch_emptyPrompt: 'संदेश खोजने के लिए कीवर्ड टाइप करें',
  chatMsgSearch_tooShort: 'खोजने के लिए कम से कम 2 अक्षर टाइप करें',
  chatMsgSearch_contactEmptyPrompt: 'संपर्क खोजने के लिए यूज़रनेम या ईमेल टाइप करें',
  chatMsgSearch_noContacts: 'कोई मिलता-जुलता संपर्क नहीं',
  chatMsgSearch_inChatPlaceholder: 'इस चैट में खोजें',
  channelHistory_title: 'इतिहास',
  channelHistory_myMessages: 'मेरे संदेश',
  channelHistory_loadMore: 'और लोड करें',
  channel_settings_push: 'Octo समूह सूचनाएं',
  channel_settings_commentPush: 'टिप्पणी सूचनाएं',
  channel_settings_likePush: 'लाइक सूचनाएं',
  channel_settings_receiveNotifications: 'सूचनाएं पाएं',
  channel_settings_directContact: 'सीधा संपर्क की अनुमति दें',
  session_published: 'प्रकाशित',
  session_publishFailed: 'प्रकाशित करने में विफल',
  session_setDirectContactSuccess: 'सेटिंग सेव हुई',
  session_setDirectContactFailed: 'सेटिंग सेव करने में विफल',
  session_setPrivate: 'प्राइवेट करें',
  session_setPublic: 'पब्लिक करें',
  session_pauseMatching: 'मिलान रोकें',
  session_resumeMatching: 'मिलान फिर शुरू करें',
  session_matchPausedToast: 'मिलान रुका है',
  session_matchResumedToast: 'मिलान फिर शुरू',
  match_matchingPausedTitle: 'मिलान रुका हुआ है',
  match_reasonTag: 'मिलान का कारण',
  match_matchingPausedHint: 'आप कभी भी मिलान दोबारा चालू कर सकते हैं।',
  session_confirmSetPrivate: 'इस कंटेंट को प्राइवेट करें? दूसरे यूज़र इसे नहीं देख पाएंगे।',
  session_messageIsPrivate: 'यह संदेश प्राइवेट है',
  chatSessionComment_replyHint: 'टिप्पणी लिखें...',
  chatSessionComment_reply: 'टिप्पणी',
  chatSessionComment_count: '{n} टिप्पणी | {n} टिप्पणियां',
  chatSessionMatch_count: '{n} मैच',
  chatSessionComment_replyTo: 'जवाब दें',
  chatSessionComment_inputHint: 'टिप्पणी लिखें...',
  chatSessionComment_send: 'भेजें',
  chatSessionComment_delete: 'डिलीट करें',
  chatSessionComment_deleteConfirm: 'क्या आप वाकई यह टिप्पणी डिलीट करना चाहते हैं?',
  chatSessionComment_loadMore: 'और लोड करें',
  chatSessionComment_noMore: 'और टिप्पणियां नहीं',
  chatSessionComment_loginToComment: 'टिप्पणी करने के लिए लॉगिन करें',
  chatSessionComment_viewEarlier: 'पिछले {n} जवाब देखें',
  chatSessionLike_like: 'पसंद करें',
  chatSessionLike_liked: 'पसंद किया',
  chatSessionLike_count: 'पसंद',
  chatSessionBookmark_bookmark: 'सेव करें',
  chatSessionBookmark_bookmarked: 'सेव किया',
  chatSessionMatch_viewMatches: 'मैच देखें',
  chatSessionMatch_matchHistory: 'मैच हिस्ट्री',
  chatSessionMatch_noMatches: 'अभी कोई मैच नहीं',
  channel_match_achievement: '{count} पोस्ट सफलतापूर्वक मैच हुए',
  channel_match_achievement_view: 'देखें →',
  channel_matchHistory_title: 'चैनल मैच हिस्ट्री',
  chatSessionMatch_matchedAt: '{time} पर मैच',
  discover_userMsgLabel: 'यूज़र ने कहा',
  common_loading: 'लोड हो रहा है...',
  common_sending: 'भेजा जा रहा है...',
  common_error: 'त्रुटि',
  common_success: 'सफल',
  common_me: 'मैं',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "AI आपकी ज़रूरत को साफ़ कर रहा है ताकि आपका हर संदेश असरदार हो; पोस्ट करने के बाद लगातार मैच ढूंढता रहेगा",
  aiChat_clarifyingAlmostDone: 'लगभग हो गया, कृपया पुष्टि करें',
  aiChat_clarifyingOneMore: 'लगभग 1 सवाल और, फिर आप पोस्ट कर सकते हैं',
  aiChat_clarifyingRemaining: 'लगभग {count} राउंड और बाकी, बहुत जल्द',
  aiChat_clarifyingEvaluating: 'प्रगति का मूल्यांकन हो रहा है...',
  aiChat_setPublicMatch: 'पब्लिक करें और मैच करें',
  aiChat_needsClarifiedPublic: "मुझे समझ आ गया। पुष्टि और पोस्ट करने के बाद, AI आपके लिए मैच ढूंढता रहेगा।\nजब चाहें और बातें बताएं।",
  aiChat_needsClarifiedPrivate: 'समझ गए! पब्लिक करें और मुझे मैच ढूंढने दें!\nजब चाहें और बातें बताएं।',
  aiChat_setPublicTitle: 'पब्लिक करें',
  aiChat_setPublicMessage: 'आपका कंटेंट दूसरों को दिखेगा ताकि OctoSay आपके लिए अनुकूल मैच ढूंढ सके।\n\nशेयर होने वाली जानकारी:\n• आपका यूज़रनेम और अवतार\n• आपके कंटेंट का सारांश\n• बातचीत का कंटेंट (खोजें में दिखेगा)\n\nआप कभी भी इसे वापस प्राइवेट कर सकते हैं।',
  aiChat_findMatches: 'मैच का नतीजा देखें',
  aiChat_publishing: 'पोस्ट हो रहा है...',
  aiChat_matchSectionTitle: 'आपका संदेश इन ग्रुप्स के लिए सबसे उपयुक्त है — पोस्ट करने के लिए टैप करें',
  aiChat_joinedBadge: 'सदस्य',
  aiChat_matchSectionEmpty: 'अभी कोई अच्छा मैच नहीं मिला — आप नया ग्रुप बनाकर वहाँ पोस्ट कर सकते हैं',
  aiChat_suggestPublishCreateNew: 'नया ग्रुप बनाएँ',
  aiChat_repickChannel: 'ग्रुप बदलें',
  aiChat_creatingChannelTitle: 'कोई उपयुक्त ग्रुप नहीं मिला — आपके लिए बनाया जा रहा है',
  aiChat_creatingChannelHint: 'AI आपके अनुरोध के अनुसार ग्रुप बना रहा है, फिर सीधे पोस्टिंग पर जाएँगे — आमतौर पर 10-30 सेकंड',
  aiChat_publishToChannelHint: '"{name}" में पोस्ट किया जाएगा',
  aiChat_pickChannelTitle: 'पोस्ट करने के लिए ग्रुप चुनें',
  aiChat_matchingChannelTitle: 'आपके लिए सही ग्रुप खोजा जा रहा है',
  aiChat_matchingChannelHint: 'AI आपके अनुरोध के आधार पर खोज रहा है — आमतौर पर कुछ सेकंड से आधा मिनट लगता है',
  aiChat_matchUnavailableTitle: 'सुझाव अभी उपलब्ध नहीं है',
  aiChat_matchUnavailableHint: 'नीचे समूह खोजें, या बंद करके प्रकाशन दोबारा खोलें',
  aiChat_waitSlowHint: 'आमतौर से अधिक समय लग रहा है, लेकिन प्रक्रिया जारी है — थोड़ा और प्रतीक्षा करें या नीचे समूह खोजें',
  aiChat_creatingSlowHint: 'ग्रुप बनने में आमतौर से अधिक समय लग रहा है, लेकिन प्रक्रिया जारी है — फिर सीधे पोस्टिंग पर जाएँगे',
  aiChat_pickChannelEmptyHint: 'संबंधित ग्रुप नहीं मिला। नया ग्रुप बनाकर अपना संदेश पोस्ट करें',
  aiChat_loadMore: 'और लोड करें',
  sidebar_publish: 'पोस्ट करें',
  chat_selectLocationOnMap: 'कृपया मैप पर लोकेशन चुनें',

  // App.vue new
  placeholder_email: 'ईमेल दर्ज करें',
  placeholder_mobile: 'मोबाइल नंबर दर्ज करें',
  placeholder_password: 'पासवर्ड दर्ज करें',
  placeholder_name: 'अपना नाम दर्ज करें',
  random_nickname: 'रैंडम',
  placeholder_verification_code: 'सत्यापन कोड दर्ज करें',
  sending: 'भेजा जा रहा है...',
  registering: 'रजिस्टर हो रहा है...',
  send_code: 'कोड भेजें',
  retry_in_seconds: '{countdown}s में फिर से कोशिश',
  toast_enter_email: 'ईमेल दर्ज करें',
  toast_enter_mobile: 'मोबाइल नंबर दर्ज करें',
  toast_invalid_email: 'कृपया मान्य ईमेल फ़ॉर्मैट दर्ज करें',
  toast_invalid_mobile: 'कृपया मान्य मोबाइल नंबर दर्ज करें',
  toast_send_code_failed: 'सत्यापन कोड भेजने में विफल',
  toast_code_sent: 'ईमेल पर सत्यापन कोड भेजा गया',
  toast_code_sent_sms: 'मोबाइल पर सत्यापन कोड भेजा गया',
  toast_send_code_error: 'सत्यापन कोड भेजने में विफल, बाद में कोशिश करें',
  toast_fill_all_fields: 'कृपया सभी फ़ील्ड भरें',
  toast_login_failed: 'लॉगिन विफल',
  toast_login_success: 'लॉगिन सफल',
  oauthOr: 'या',
  toast_oauth_login_failed: 'Google लॉगिन विफल',
  toast_oauth_login_error: 'Google लॉगिन में त्रुटि, फिर से कोशिश करें',
  toast_login_error: 'लॉगिन विफल, बाद में कोशिश करें',
  toast_register_failed: 'रजिस्ट्रेशन विफल',
  toast_register_success: 'रजिस्ट्रेशन सफल',
  toast_register_error: 'रजिस्ट्रेशन विफल, बाद में कोशिश करें',

  // AdBanner.vue
  ad: 'विज्ञापन',

  // ContactAdGate.vue 联系前广告闸门
  contactAd_gateTitle: 'जुड़ने से पहले',
  contactAd_gateSubtitle: 'यह छोटा विराम OctoSay को मुफ़्त रखता है — आपके समर्थन के लिए धन्यवाद!',
  contactAd_waitBtn: '{sec}s में जारी रखें',
  contactAd_continueBtn: 'चैट पर जारी रखें',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: 'चैट',

  // AiMatch.vue
  ai_welcome_msg: 'नमस्ते, मैं AI हूं। बताइए क्या मन में है — साथी, पार्टनर, स्किल एक्सचेंज, या कुछ भी।',
  default_username: 'यूज़र',

  // AvatarCropDialog.vue
  crop_hint: 'ज़ूम के लिए पिंच करें, एडजस्ट करने के लिए ड्रैग करें',
  toast_crop_failed: 'इमेज क्रॉप करने में विफल',

  // ChatBox.vue
  loading_match_info: 'मैच जानकारी लोड हो रही है...',
  view_match_details: 'मैच विवरण देखें',
  step_clarify_needs: 'साफ करें',
  step_ai_matching: 'समूह में पोस्ट करें',
  step_connect: 'AI मैच',
  make_private: 'प्राइवेट करें',
  setting: 'सेट हो रहा है...',
  action_photo: 'फ़ोटो',
  action_file: 'फ़ाइल',
  action_video: 'वीडियो',
  action_location: 'लोकेशन',
  hint_get_app: 'जुड़े रहने के लिए ऐप पाएं',
  match_finding_title: 'आपके मैच',
  match_finding_subtitle: 'AI आपके लिए लगातार मैच ढूंढ रहा है',
  match_time_hint: 'इस प्रक्रिया में आमतौर पर 1-2 मिनट लगते हैं',
  match_result_stats: '{matched} सबसे अच्छे मैच मिले{interested}',
  match_tap_to_connect: 'बातचीत शुरू करने के लिए टैप करें',
  match_channel_hint: 'समूह <strong>#{channel}</strong> में मैचिंग हो रही है। एक ही hub को प्राथमिकता, लेकिन ज़रूरत पर दूसरे hubs भी शामिल हो सकते हैं।',
  label_perfect_match: 'सबसे अच्छा मैच',
  label_worth_a_look: 'देखने लायक',
  match_no_result_title: 'आपके लिए मैच ढूंढ रहे हैं',
  match_no_result_desc: 'OctoSay को सही मैच ढूंढने में मदद के लिए और बातें शेयर करें। मैच होने पर सूचना पाने के लिए ऐप इंस्टॉल करें।',
  go_back: 'वापस जाएं',
  no_public_requirements: 'अभी कोई सार्वजनिक पोस्ट नहीं',
  channelEmpty_title: 'यहां अभी शांत है',
  channelEmpty_subtitle: 'अपने विचार शेयर करने वाले पहले व्यक्ति बनें',
  channelEmpty_hint: "अपने विचार लिखें और AI आपकी बातें साफ करने और लगातार मैचिंग में मदद करेगा, ताकि आपका संदेश दबा न रहे",
  channelEmpty_action: 'अपने विचार शेयर करें',
  stay_connected: 'जुड़े रहें',
  download_app_desc: 'ऐप पाएं और चैट करें, जब कोई आपसे जुड़े तो तुरंत नोटिफिकेशन पाएं!',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: 'सीधा APK',
  match_history: 'मैच हिस्ट्री',
  no_match_history: 'अभी कोई मैच हिस्ट्री नहीं',
  finding_matches: 'AI लगातार मैच ढूंढ रहा है - समूह में संदेश पोस्ट करने के बाद',
  discover_connect_hint: 'मैच होने पर आप उनसे चैट कर सकते हैं!',
  match_initializing: 'शुरू हो रहा है...',
  placeholder_login_to_chat: 'लॉगिन करें और बताएं क्या मन में है',
  toast_need_clear: 'आपकी बात साफ हो गई!',
  toast_ai_responding: 'AI जवाब दे रहा है, कृपया प्रतीक्षा करें...',
  toast_uploading_image: 'इमेज अपलोड हो रही है, कृपया प्रतीक्षा करें...',
  toast_uploading_file: 'फ़ाइल अपलोड हो रही है, कृपया प्रतीक्षा करें...',
  toast_max_photos: 'अधिकतम {max} फ़ोटो की अनुमति',
  toast_uploading: 'अपलोड हो रहा है, कृपया प्रतीक्षा करें...',
  toast_file_too_large: '{name} 5MB की सीमा से बड़ा है',
  toast_video_too_large: '{name} 20MB की सीमा से बड़ा है',
  toast_video_processing: 'वीडियो प्रोसेस हो रहा है, कृपया प्रतीक्षा करें…',
  toast_upload_link_failed: 'अपलोड लिंक लेने में विफल',
  analyzing_image: 'इमेज का विश्लेषण हो रहा है...',
  toast_location_confirmed: 'लोकेशन पुष्ट',
  toast_location_selected: 'लोकेशन चुनी गई',
  toast_enter_search: 'कृपया खोजने का कंटेंट दर्ज करें',
  toast_search_failed: 'खोज विफल',
  toast_no_locations: 'कोई लोकेशन नहीं मिली',
  toast_search_error: 'खोज विफल, फिर से कोशिश करें',
  toast_located_at: 'लोकेशन: {address}',
  toast_shared_finding: 'शेयर हुआ! मैच ढूंढे जा रहे हैं...',
  toast_update_failed: 'अपडेट विफल',
  toast_set_private: 'प्राइवेट कर दिया गया',
  toast_no_matches: 'कोई मैच नहीं मिला',
  toast_matches_found: '{count} सबसे अच्छे मैच मिले',
  toast_start_conversation_first: 'पहले बातचीत शुरू करें',
  toast_load_history_failed: 'मैच हिस्ट्री लोड करने में विफल',
  toast_ai_timeout: 'AI का जवाब देर हो गई, फिर से कोशिश करें',
  toast_message_blocked: 'संदेश ब्लॉक हुआ',
  network_disconnected: 'नेटवर्क डिस्कनेक्ट हो गया',
  toast_publish_success: 'समूह में पोस्ट हुआ!',
  toast_publish_failed: 'समूह में पोस्ट करने में विफल',

  // ChatMsgList.vue
  collapse_thinking: 'सोचने की प्रक्रिया छिपाएं',
  expand_thinking: 'सोचने की प्रक्रिया दिखाएं',
  thinking: 'सोच रहे हैं',
  select_date: 'तारीख चुनें',
  selected_location: 'चुनी गई लोकेशन',
  msg_blocked: 'ब्लॉक हुआ',
  retry: 'फिर से कोशिश करें',
  msg_read: 'पढ़ा गया',
  msg_sent: 'भेजा गया',
  msg_unread: 'अनपढ़ा',
  label_start_datetime: 'शुरुआत की तारीख और समय:',
  label_end_datetime: 'समाप्ति की तारीख और समय:',
  toast_select_start_datetime: 'कृपया शुरुआत की तारीख और समय चुनें',
  toast_end_before_start: 'समाप्ति की तारीख-समय शुरुआत से पहले नहीं हो सकती',
  report_message: 'संदेश रिपोर्ट करें',
  block_user: 'यूज़र ब्लॉक करें',
  msg_revoke: 'वापस लें',
  msg_quote: 'उद्धृत करें',
  msg_revoked_self: 'आपने एक संदेश वापस लिया',
  msg_revoked_other: 'दूसरे पक्ष ने एक संदेश वापस लिया',
  // Neutral text inside quote block: the revoker is the sender of the quoted message, unrelated to current message direction
  msg_revoked_generic: 'संदेश वापस लिया गया',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: 'नियमों के उल्लंघन के कारण प्लेटफ़ॉर्म ने यह संदेश हटा दिया है',
  msg_blocked_label: 'This message was blocked by the platform',
  toast_revoke_success: 'संदेश वापस लिया गया',
  toast_revoke_failed: 'संदेश वापस लेने में विफल',
  toast_load_data_failed: 'डेटा लोड करने में विफल, कृपया रिफ्रेश करें।',
  toast_file_url_missing: 'फ़ाइल URL नहीं मिला',
  toast_block_success: 'यूज़र सफलतापूर्वक ब्लॉक हुआ',
  toast_block_failed: 'यूज़र ब्लॉक करने में विफल',

  // ChatSession.vue
  no_more_records: 'और रिकॉर्ड नहीं।',
  title_needs_clarified: 'विचार साफ हो गए',
  title_clarifying: 'आपके विचारों को साफ कर रहे हैं',
  title_public: 'सार्वजनिक',
  title_private: 'प्राइवेट',
  badge_clarified: 'साफ हो गया',
  badge_clarifying: 'साफ हो रहा है',
  badge_only_me: 'केवल मैं',
  badge_expired: 'समाप्त',
  title_expired: 'समाप्त',
  no_chat_history: 'कोई चैट हिस्ट्री नहीं',

  // ContactMethods.vue
  block_status_banner: 'आपने इस यूज़र को ब्लॉक कर दिया है',
  unblock_user: 'अनब्लॉक करें',
  toast_block_missing_id: 'ब्लॉक नहीं कर सकते: यूज़र ID नहीं है',
  dialog_block_confirm: 'क्या आप वाकई {name} को ब्लॉक करना चाहते हैं? आपको उनके संदेश नहीं मिलेंगे।',
  toast_user_blocked: '{name} ब्लॉक कर दिया गया',
  toast_unblock_missing_id: 'अनब्लॉक नहीं कर सकते: यूज़र ID नहीं है',
  toast_user_unblocked: '{name} अनब्लॉक कर दिया गया',

  // BlockedUsers.vue
  blocked_users: 'ब्लॉक किए गए यूज़र',
  blocked_users_empty: 'कोई ब्लॉक किया यूज़र नहीं',
  blocked_users_empty_hint: 'ब्लॉक किए गए यूज़र आपको संदेश नहीं भेज पाएंगे',
  blocked_users_unblock: 'अनब्लॉक करें',
  dialog_unblock_confirm: 'अनब्लॉक करने के बाद वे आपको फिर संदेश भेज पाएंगे।',
  toast_unblock_success: 'अनब्लॉक हो गया',
  toast_unblock_failed: 'अनब्लॉक करने में विफल, फिर से कोशिश करें',
  blocked_users_load_failed: 'लोड करने में विफल। दोबारा कोशिश के लिए टैप करें',
  blocked_users_blocked_at: '{date} को ब्लॉक किया',
  blocked_users_unknown_user: 'अज्ञात यूज़र',

  // Contacts.vue
  no_connections: 'अभी कोई संदेश नहीं',
  chat_with: '{name} के साथ चैट',
  toast_load_contacts_failed: 'कनेक्शन लोड करने में विफल: {msg}',
  toast_load_contacts_error: 'कनेक्शन लोड करने में विफल। कृपया रिफ्रेश करके दोबारा कोशिश करें।',
  time_just_now: 'अभी',
  time_minutes_ago: '{min}म पहले',
  time_hours_ago: '{hour}घं पहले',
  time_days_ago: '{day}दि पहले',

  // InteractionNotification.vue
  interaction_notification_title: 'सूचनाएं',
  interaction_notification_subtitle: 'टिप्पणियां और पसंद',
  interaction_notification_empty: 'अभी कोई सूचना नहीं',
  interaction_notification_comment: 'ने टिप्पणी की: {content}',
  interaction_notification_like: 'ने आपकी पोस्ट पसंद की',
  interaction_notification_reply: 'ने जवाब दिया: {content}',
  interaction_notification_bookmark: 'ने आपकी पोस्ट सेव की',
  toast_load_notifications_failed: 'सूचनाएं लोड करने में विफल: {msg}',
  toast_load_notifications_error: 'सूचनाएं लोड करने में विफल। कृपया रिफ्रेश करके दोबारा कोशिश करें।',
  mark_all_read: 'सभी पढ़ा हुआ मार्क करें',
  toast_mark_all_read_failed: 'काम विफल, फिर से कोशिश करें',
  contacts_dnd: 'सूचनाएं म्यूट करें',
  dnd_enabled: 'सूचनाएं म्यूट हुईं',
  dnd_disabled: 'सूचनाएं अनम्यूट हुईं',
  dnd_action_enable: 'सूचनाएं म्यूट करें',
  dnd_action_disable: 'सूचनाएं अनम्यूट करें',

  // Discover.vue
  toast_load_sessions_failed: 'सेशन लोड करने में विफल: {msg}',
  toast_load_sessions_error: 'सेशन लोड करने में विफल',
  discover_noMessages: 'अभी कोई संदेश नहीं',

  // EmojiInputArea.vue
  placeholder_default: 'AI को और बातें बताएं',
  userChat_typeMessage: 'संदेश टाइप करें...',
  select_emoji: 'इमोजी चुनें',
  badge_new: 'नया',
  channel_search_placeholder: 'चैनल दर्ज करें',
  channel_picker_empty: 'चैनल दर्ज करें',

  // FrontPage.vue
  tab_chat_with_ai: 'OctoSay को आपको समझने दें',
  history_chats: 'इतिहास',
  tab_connections: 'मैच',
  tab_conversations: 'संदेश',
  tab_profile: 'प्रोफ़ाइल',
  new_session: 'नया',
  history_tab_chats: 'मेरे',
  history_tab_matches: 'मैच',
  channels_octosay: 'Octo समूह',
  tab_matches: 'मैच',
  tab_messages: 'संदेश',

  // Header.vue
  slogan: 'OctoSay - AI जो आपको समझता है और आपको सही इंसान से जोड़ता है',
  app_name: 'OctoSay',
  slogan_short: 'AI जो आपको समझता है और आपको सही इंसान से जोड़ता है',
  slogan_ai: 'AI जो आपको समझता है और आपको सही इंसान से जोड़ता है',
  get_the_app: 'ऐप पाएं',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: 'या app stores में OctoSay खोजें',

  // MapLocationPicker.vue
  placeholder_search_location: 'लोकेशन खोजें...',
  coords_display: 'देशांतर: {lng}, अक्षांश: {lat}',
  toast_no_geolocation: 'आपका ब्राउज़र जियोलोकेशन को सपोर्ट नहीं करता',
  toast_location_permission_denied: 'आपकी लोकेशन नहीं मिल सकी, कृपया लोकेशन अनुमतियां जांचें',
  loading_address: 'पता लोड हो रहा है...',

  // MatchedSession.vue
  created_at: 'बनाया गया: {time}',
  ai_match_analysis: 'AI मैच विश्लेषण',
  error_missing_session_params: 'ज़रूरी सेशन पैरामीटर मौजूद नहीं',
  match_private_hint: 'यह सेशन प्राइवेट है। कंटेंट उपलब्ध नहीं',

  // PersonalCenter.vue
  label_name: 'नाम:',
  placeholder_enter_name: 'अपना नाम दर्ज करें',
  label_bio: 'बायो:',
  placeholder_enter_bio: 'अपने बारे में कुछ लिखें',
  placeholder_bio_empty: 'अपने बारे में कुछ बताएं',
  bio: 'बायो',
  delete_account: 'अकाउंट डिलीट करें',
  delete_warning: 'यह क्रिया पूर्ववत नहीं की जा सकती।',
  delete_data_intro: 'निम्नलिखित डेटा स्थायी रूप से डिलीट हो जाएगा:',
  delete_item_profile: 'आपकी प्रोफ़ाइल जानकारी',
  delete_item_chat: 'चैट हिस्ट्री और सेशन',
  delete_item_contact: 'संपर्क जानकारी',
  delete_item_all: 'सभी संबंधित डेटा',
  final_confirmation: 'अंतिम पुष्टि',
  delete_confirm_prompt: 'पुष्टि के लिए "delete" टाइप करें:',
  placeholder_type_delete: 'delete टाइप करें',
  private_token: 'प्राइवेट टोकन',
  token_desc: 'API एक्सेस के लिए टोकन बनाएं',
  toast_not_logged_in: 'उपयोगकर्ता लॉगिन नहीं है',
  toast_name_required: 'नाम ज़रूरी है',
  toast_save_success: 'सफलतापूर्वक सेव हुआ',
  toast_save_failed: 'सेव करने में विफल',
  toast_image_too_large: 'इमेज 5MB की सीमा से बड़ी है',
  toast_avatar_updated: 'अवतार अपडेट हुआ',
  toast_avatar_failed: 'अवतार अपडेट करने में विफल',
  toast_upload_failed: 'अपलोड विफल',
  toast_token_generated: 'टोकन बन गया',
  toast_token_failed: 'टोकन बनाने में विफल',
  toast_copied: 'क्लिपबोर्ड पर कॉपी हुआ',
  toast_copy_failed: 'कॉपी करने में विफल',
  toast_account_deleted: 'अकाउंट सफलतापूर्वक डिलीट हुआ',
  toast_delete_account_failed: 'अकाउंट डिलीट करने में विफल',
  toast_logout_success: 'लॉगआउट सफल',
  toast_logout_failed: 'लॉगआउट विफल',
  profile_tab_messages: 'संदेश',
  profile_tab_comments: 'टिप्पणियां',
  profile_tab_likes: 'पसंद',
  profile_tab_bookmarks: 'सेव किए गए',
  profile_empty_messages: 'अभी कोई संदेश नहीं',
  profile_empty_comments: 'अभी कोई टिप्पणी नहीं',
  profile_empty_likes: 'अभी कोई पसंद नहीं',
  profile_empty_bookmarks: 'अभी कुछ सेव नहीं किया',
  profile_reply_to: '{name} को जवाब',
  profile_stats_posts: 'संदेश',
  profile_stats_comments: 'टिप्पणियां',
  profile_stats_likes: 'मिली पसंद',
  profile_joined: '{date} को जुड़े',

  // ReportDialog.vue
  report_message_title: 'संदेश रिपोर्ट करें',
  report_reason_prompt: 'कृपया इस संदेश की रिपोर्ट करने का कारण चुनें:',
  report_spam: 'स्पैम',
  report_harassment: 'परेशानी या धमकी',
  report_inappropriate: 'अनुचित कंटेंट',
  report_other: 'अन्य',
  placeholder_report_desc: 'समस्या बताएं (वैकल्पिक)',
  toast_select_reason: 'कृपया कारण चुनें',
  toast_report_success: 'रिपोर्ट सफलतापूर्वक सबमिट हुई',
  toast_report_failed: 'रिपोर्ट सबमिट करने में विफल',

  // common.js
  ellipsis: '..',

  // ChatBox.vue / ChatMsgList.vue message summary prefixes
  summary_image: '[इमेज]',
  summary_images: '[इमेज x{count}]',
  summary_file: '[फ़ाइल]',
  summary_files: '[फ़ाइल x{count}]',
  summary_video: '[वीडियो]',
  summary_videos: '[वीडियो x{count}]',
  summary_location: '[लोकेशन]',
  summary_locations: '[लोकेशनx{count}]',
  summary_emoji: '[इमोजी]',
  summary_emojis: '[इमोजी x{count}]',
  summary_voice: '[वॉइस]',
  summary_voices: '[वॉइसx{count}]',
  summary_mixed: '[मिश्रित]',
  summary_other: '[अन्य]',

  // Voice messages
  voice: 'वॉइस',
  voice_recording: 'रिकॉर्डिंग हो रही है...',
  toast_voice_too_short: 'रिकॉर्डिंग बहुत छोटी है',
  toast_voice_failed: 'वॉइस भेजने में विफल',
  toast_mic_permission_denied: 'माइक्रोफ़ोन तक नहीं पहुंच सकते। कृपया ब्राउज़र सेटिंग्स में चालू करें',
  toast_recording_not_supported: 'यह ब्राउज़र वॉइस रिकॉर्डिंग को सपोर्ट नहीं करता',
  voice_load_failed: 'वॉइस संदेश लोड करने में विफल',

  // Expire At
  aiChat_expireLine: '{date} तक मान्य, अपडेट के लिए AI को कभी भी बताएं',
  aiChat_expireExpired: 'कंटेंट समाप्त हो गया और दूसरों को दिखाई नहीं देगा। अपडेट के लिए AI को कभी भी बताएं',

  // MatchedSession.vue
  detail: 'विवरण',

  // Match notification hints
  match_new_result_hint: 'बाद में नए मैच नतीजे आने पर आपको सूचित किया जाएगा। बेहतर अनुभव के लिए ऐप इंस्टॉल करें और तुरंत नोटिफिकेशन पाएं।',

  // Match notification hints
  match_connection_notify_hint: 'मैच हो गया और सूचित भी! जल्दी हैलो कहें!',
  match_continuousMatching: 'AI आपके लिए लगातार मैच ढूंढ रहा है',
  match_continuousMatchingHint: 'नए मैच मिलते ही हम आपको बता देंगे',
  match_continuousMatchingOthers: 'AI उनके लिए लगातार मैच ढूंढ रहा है',
  match_continuousMatchingOthersHint: 'नए मैच यहां दिखाई देंगे जैसे ही मिलेंगे',
  match_noResultsTitleOthers: 'उनके लिए मैच ढूंढ रहे हैं',
  match_noResultsHintOthers: 'AI उनके लिए लगातार मैच ढूंढ रहा है। मिलने पर नतीजे यहां दिखेंगे।',
  match_newMatchFound: '{n} नए मैच मिले!',
  match_worth_exploring_hint: 'संपर्क करना है या नहीं, यह आप तय करें।',

  // Matches filter tags
  filter_all: 'सभी',
  filter_best_connection: 'सबसे अच्छा मैच',
  filter_worth_a_look: 'देखने लायक',

  // LandingPage.vue (CN Portal)
  landing_brand_slogan: 'OctoSay - AI जो आपको समझता है और आपको सही इंसान से जोड़ता है',
  landing_hero_title: 'अपने hub में लिखें — AI पहले साफ करेगा, फिर आप प्रकाशित करेंगे और मैच पाएंगे।',
  landing_hero_subtitle: 'Octo समूह में वह संदेश लिखें जिसे आप शेयर करना चाहते हैं। प्रकाशित होने से पहले AI आपसे बात करके बातें साफ करेगा। पुष्टि करने पर आपका संदेश और AI सारांश साथ पोस्ट होंगे, और AI मैचिंग शुरू कर देगा।',
  landing_download_on: 'डाउनलोड करें',
  landing_get_it_on: 'पाएं',
  landing_direct_download: 'सीधा डाउनलोड',
  landing_how_title: 'कैसे काम करता है',
  landing_step1_title: 'समूह में लिखें',
  landing_step1_desc: 'समूह में वह संदेश लिखें जिसे आप शेयर करना चाहते हैं। AI पहले आपसे बात करके बातें साफ करेगा, ताकि हर पोस्ट स्पष्ट, उपयोगी और मैच के लिए तैयार हो — शोर में खो न जाए।',
  landing_step2_title: 'पुष्टि करें, पोस्ट करें और मैच पाएं',
  landing_step2_desc: 'पुष्टि करने पर आपका मूल संदेश और AI सारांश साथ ही hub में पोस्ट होते हैं। इसके बाद AI लगातार आपके लिए सबसे अच्छे मैच ढूंढता रहता है, ताकि आपका संदेश दबकर न रह जाए।',
  landing_step3_title: 'जुड़ें और बात करें',
  landing_step3_desc: 'मैच मिलने पर दोनों पक्ष एक-दूसरे की AI के साथ चैट हिस्ट्री और AI सारांश देख सकते हैं। साझा संदर्भ के साथ, बर्फ तोड़ना आसान है — बस स्वाभाविक रूप से बात करें।',
  // Comparison Section
  landing_comparison_title: 'OctoSay क्यों?',
  landing_comparison_subtitle: 'समूह चैट, लेकिन AI आपकी बातें साफ करता और खुद मैच कराता है।',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: 'कंटेंट की गुणवत्ता',
  landing_cmp1_other: 'स्पैम, विज्ञापन और टॉपिक से इतर सैलाब',
  landing_cmp1_octo: 'सिर्फ AI-चुने हुए ज़रूरत कार्ड',
  landing_cmp2_label: 'लोग ढूंढना',
  landing_cmp2_other: 'पोस्ट करें और बस जवाबों का इंतज़ार',
  landing_cmp2_octo: 'AI खुद आपके लिए मैच कराता है',
  landing_cmp3_label: 'शोर की मात्रा',
  landing_cmp3_other: 'सैकड़ों संदेश स्क्रॉल करने पड़ते हैं',
  landing_cmp3_octo: 'शून्य शोर, हर पोस्ट का मतलब है',
  landing_cmp4_label: 'शुरुआत',
  landing_cmp4_other: 'सर्वर ढूंढें, चैनल देखें, खुद सीखें',
  landing_cmp4_octo: 'समूह में लिखें; AI साफ और मैच करेगा',
  landing_cmp_other_wechat: 'WeChat',
  landing_cmp_other_xhs: 'Xiaohongshu',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: 'ग्रुप चैट विज्ञापन और स्पैम से भरी',
  landing_cmp1_xhs: 'प्रमोशनल पोस्ट हर तरफ, भरोसा मुश्किल',
  landing_cmp1_facebook: 'विज्ञापन और क्लिकबेट फीड में चाए',
  landing_cmp1_reddit: 'स्पैम और टॉपिक से इतर पोस्ट हर तरफ',
  landing_cmp2_wechat: 'सिर्फ कॉन्टैक्ट और ग्रुप इनवाइट से',
  landing_cmp2_xhs: 'खुद खोजो और पोस्ट खंगालो',
  landing_cmp2_facebook: 'मौजूदा दोस्तों और ग्रुपों तक सीमित',
  landing_cmp2_reddit: 'खुद सबरेडिट देखो और जवाब की उम्मीद करो',
  landing_cmp3_wechat: 'सैकड़ों ग्रुप संदेश स्क्रॉल',
  landing_cmp3_xhs: 'फीड भरी है रिकमेंडेशन और विज्ञापन से',
  landing_cmp3_facebook: 'रिकमेंडेड पोस्ट और विज्ञापन खत्म नहीं होते',
  landing_cmp3_reddit: 'सैकड़ों कमेंट स्क्रॉल करने पड़ते हैं',
  landing_cmp5_label: 'कौन ढूंढता है',
  landing_cmp5_wechat: 'एक-एक करके पूछो, किस्मत आजमाओ',
  landing_cmp5_xhs: 'पोस्ट करो, कमेंट का इंतज़ार करो, खुद छानो',
  landing_cmp5_facebook: 'ग्रुपों में इधर-उधर पूछना पड़ता है',
  landing_cmp5_reddit: 'पोस्ट करो, जवाब का इंतज़ार करो, फिर छानो',
  landing_cmp5_octo: 'AI आपके लिए अपने-आप लगातार लोग ढूंढता है',

  landing_features_title: 'मुख्य फ़ीचर',
  landing_feature1_title: 'प्रकाशित करने से पहले साफ करें',
  landing_feature1_desc: 'फ़ॉर्म भरने की ज़रूरत नहीं। समूह में अपना संदेश लिखें और AI पहले आपसे बात करके सही सवाल पूछेगा और आपकी ज़रूरत को सच में समझेगा।',
  landing_feature2_title: 'साफ, गड़बड़ नहीं',
  landing_feature2_desc: 'आपका संदेश और AI सारांश साथ पोस्ट होते हैं — OctoSay हर पोस्ट को छांटता है, इसलिए न स्पैम, न टॉपिक से इतर सैलाब, न स्क्रॉल करने लायक शोर।',
  landing_feature3_title: 'सक्रिय मैचिंग',
  landing_feature3_desc: 'पुष्टि करने और आपके संदेश + AI सारांश के लाइव होने के बाद, AI hub को लगातार स्कैन करता है ताकि आपकी तलाश से मेल खाने वाले लोगों को ढूंढ सके — और कारण भी बताता है।',
  landing_feature4_title: 'टॉपिक कम्युनिटी, शून्य शोर',
  landing_feature4_desc: 'टॉपिक hubs से जुड़ें — स्पोर्ट्स, गेमिंग, भाषा एक्सचेंज, रूममेट — AI प्रकाशित करने से पहले आपका संदेश साफ करता है, इसलिए हर hub साफ और उपयोगी रहता है।',
  landing_feature5_title: 'गोपनीयता सुरक्षित',
  landing_feature5_desc: 'भेजने के बाद संदेश प्राइवेट कर सकते हैं, सिर्फ आप देख सकते हैं। पूरा नियंत्रण।',
  landing_feature6_title: 'अर्थपूर्ण बातचीत',
  landing_feature6_desc: 'न शोर, न बिखरी हुई परेशानियां — हर संदेश का मतलब है।',
  landing_usecases_title: 'किसी भी स्थिति में काम करता है',
  landing_usecases_subtitle: 'मन में जो भी हो, टॉपिक hub से जुड़ें — मैचिंग AI संभाल लेगा ताकि आपको स्क्रॉल और खोज न करनी पड़े',
  landing_usecase_game: 'गेमिंग साथी',
  landing_usecase_language: 'भाषा एक्सचेंज',
  landing_usecase_skill: 'स्किल एक्सचेंज',
  landing_usecase_roommate: 'रूममेट ढूंढें',
  landing_usecase_travel: 'यात्रा साथी',
  landing_usecase_sports: 'स्पोर्ट्स पार्टनर',
  landing_usecase_study: 'स्टडी पार्टनर',
  landing_usecase_anything: '...या कुछ भी शेयर करें',
  landing_cta_title: 'शुरू करने के लिए तैयार?',
  landing_cta_desc: 'टॉपिक hub से जुड़ें, शेयर करने लायक लिखें, AI को बातें साफ करने दें, फिर प्रकाशित करें और सही लोगों से मैच पाएं।',
  landing_use_now: 'अभी इस्तेमाल करें',
  landing_groups: 'समूह',

  // OnboardingPage.vue
  onboarding_skip: 'छोड़ें',
  onboarding_next: 'आगे',
  onboarding_getStarted: 'शुरू करें',
  onboarding_step1Title: "ग्रुप में बताएं आपको क्या चाहिए",
  onboarding_step1Desc: "आप क्या ढूंढ रहे हैं या क्या करना चाहते हैं, सीधे बता दें। AI आपसे बात करके बातें साफ करेगा और उसे एक साफ़ संदेश में बदल देगा।",
  onboarding_step2Title: 'पुष्टि करें, पोस्ट करें और मैच पाएं',
  onboarding_step2Desc: "संदेश hub में पोस्ट होते ही AI लगातार आपके लिए सबसे अच्छे मैच ढूंढता रहता है, ताकि आपका संदेश दबकर न रह जाए।",
  onboarding_step3Title: 'जुड़ें और बात करें',
  onboarding_step3Desc: "दोनों पक्ष एक-दूसरे की AI के साथ हुई बातचीत देख सकते हैं और जान सकते हैं कि सामने वाला क्या चाहता है। साझा संदर्भ के साथ, बर्फ तोड़ना आसान है — बस स्वाभाविक रूप से बात करें।",

  // ChannelDetail.vue
  channel_image_limit: 'अधिकतम 1 इमेज',

  // ChannelMembers.vue
  channel_members_empty: 'अभी कोई सदस्य नहीं',
  channel_members_title: 'सदस्य',
  channel_role_owner: 'मालिक',
  channel_role_admin: 'एडमिन',
  channel_role_member: 'सदस्य',

  // Settings.vue
  settings_language: 'भाषा',
  settings_language_followSystem: 'सिस्टम के अनुसार',

  // ChatBox.vue
  match_interested_suffix: ', {count} देखने लायक',

  // ChatBox.vue - AI मिलान प्रगति के चरण
  match_stage_fetch_chat: 'बातचीत ली जा रही है',
  match_stage_query_expansion: 'क्वेरी विस्तारित की जा रही हैं',
  match_stage_semantic_search: 'सिमैंटिक खोज',
  match_stage_deep_search: 'गहन विश्लेषण',
  match_stage_rerank: 'स्मार्ट मिलान',
  match_stage_refining: 'परिणामों को बेहतर बनाया जा रहा है',
  match_stage_fetch_details: 'विवरण लिया जा रहा है',

  // ChannelDetail.vue - छवि अपलोड
  channel_select_image: 'कृपया एक छवि फ़ाइल चुनें',
  channel_image_upload_failed: 'छवि अपलोड विफल, कृपया पुनः प्रयास करें',
  chatInput_channelSearchHint: "ग्रुप खोजें",
}



// WEBPACK FOOTER //
// ./src/i18n/hi.js